export const generateArrayFromLength = (length: number) =>
	Array.from({ length }, (_, i) => i);
